import React from 'react';
import Masonry from 'react-masonry-css';
import { goSingleStory } from '../../utils';
import StoryDisplay from '../StoryDisplay';

const MAX_RELATED = 12;

export default function RelatedStories({ classes, story, navigate }) {
	const items = (story?.related_stories || []).slice(0, MAX_RELATED);
	if (!items.length) return null;

	return (
		<Masonry
			breakpointCols={1}
			className={classes.masonryGrid}
			columnClassName={classes.masonryGridColumn}
		>
			{items.map((item, i) => (
				<div key={item.uuid || item.slug || i}>
					<StoryDisplay
						story={item}
						onClick={() => goSingleStory(item.slug, navigate)}
						onLoad={null}
						eager
					/>
				</div>
			))}
		</Masonry>
	);
}
